module.exports = __webpack_public_path__ + "static/media/oz_logo.f3f66ac0.svg";